{
  "en": {
    "processing-action-label": "Processing surveys...",
    "distribute-action-label": "Delivering charts...",
    "generated-layers": "Generated layers",
    "distribute": "Distribute",
    "process-panel": "Process panel",
    "process-surveys": "Process surveys",
    "upload-surveys": "Select new surveys",
    "config-title": "bENC tile sets",
    "select-surveys": "Select surveys",
    "bENC": "bENC",
    "no-source-data": "No source data here...",
    "reprocess-surveys": "Reprocess surveys",
    "log-monitoring": "Monitoring of Ulhysses processing logs",
    "close-log-tracking": "Close"
  },
  "fr": {
    "processing-action-label": "Traitement des levés...",
    "distribute-action-label": "Livraison...",
    "generated-layers": "Couches générées",
    "distribute": "Distribuer",
    "process-panel": "Panneau de traitement",
    "process-surveys": "Lancer le calcul",
    "upload-surveys": "Ajouter de nouveaux levés",
    "config-title": "Configurations de BENC",
    "select-surveys": "Selection des levés",
    "bENC": "BENC",
    "no-source-data": "Pas de levés source trouvés...",
    "reprocess-surveys": "Relancer le calcul",
    "log-monitoring": "Suivi des journaux de traitement d'Ulhysses",
    "close-log-tracking": "Fermer"
  }
}